export default __webpack_public_path__ + "static/media/enroll.478df931.png";